import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EditableCompany } from '../editable-company';
import { first, of, shareReplay, switchMap, tap } from 'rxjs';
import { CompanyFormModel } from 'src/app/core/models/company/company-form.model';
import { CompanyService } from 'src/app/core/services/company.service';
import { Router } from '@angular/router';
import { CustomFile } from 'src/app/core/models/customFile.interface';
import { Util } from 'src/app/core/utils/util';
import { ObservableUtil } from 'src/app/core/utils/observable-util';
import { FileService } from 'src/app/core/services/file.service';

@Component({
    selector: 'app-create-company',
    templateUrl: './create-company.component.html',
    styleUrls: ['./create-company.component.scss'],
    providers: [CompanyFormModel],
    standalone: false
})
export class CreateCompanyComponent extends EditableCompany {
  activeModal = inject(NgbActiveModal);
  formModel: CompanyFormModel;
  private readonly companyService = inject(CompanyService);
  private readonly fileService = inject(FileService);
  private router = inject(Router);

  public titleImagePath = `companies/${Util.generateGUID()}`;

  constructor() {
    const formModel = inject(CompanyFormModel);

    super(formModel);
  
    this.formModel = formModel;
  }

  public submitForm(): void {
    const extensionName = Util.getExtensionFromFileTitle(
      this.companyImage?.file.name,
    );
    const imageExtension = extensionName ? `.${extensionName}` : undefined;
    const companyId = this.titleImagePath.split('/').pop()!;
    const baseCompanyUrl = `companies/${companyId}`;

    this.companyService
      .createCompany(this.formModel.form, companyId, imageExtension)
      .pipe(
        first(),
        switchMap(() =>
          imageExtension
            ? this.fileService.deleteTemporaryFileInfo(
                `${baseCompanyUrl}/title${imageExtension}`,
              )
            : of(null),
        ),
        tap(() => {
          this.activeModal.close(companyId);
          this.router.navigateByUrl(`${baseCompanyUrl}/projects`);
        }),
      )
      .subscribe();
  }

  public onUploadFile(event: CustomFile): void {
    this.companyImage = event;

    this.previewUrl$ = ObservableUtil.getFilePreview$(
      this.companyImage.file,
    ).pipe(shareReplay(1));
  }

  public onDeleteFile(): void {
    this.companyImage = undefined;
    this.previewUrl$ = of();
  }
}
